import { Link } from "react-router-dom";
import CustomizedCardHeader from "../../components/customized-card-header/CustomizedCardHeader";
import {
    ContainerApp,
    CustomizedCard,
    CustomizedCardBody,
    Icon,
    TitleCard
} from "./style";

const AuthView = () => {
    return (
        <CustomizedCard>
            <CustomizedCardHeader
                className={"border-bottom"}
                initialName={`Auth:`}
            />
            <CustomizedCardBody>
                <Link to={{ pathname: "/auth/scopes" }}>
                    <ContainerApp>
                        <Icon className="material-icons">local_police</Icon>
                        <TitleCard>Escopos</TitleCard>
                    </ContainerApp>
                </Link>
                <Link to={{ pathname: "/auth/roles" }}>
                    <ContainerApp>
                        <Icon className="material-icons">badge</Icon>
                        <TitleCard>Roles</TitleCard>
                    </ContainerApp>
                </Link>
            </CustomizedCardBody>
        </CustomizedCard>
    );
};

export default AuthView;
